module.exports = __webpack_public_path__ + "img/2.52c7911d.png";